import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListCustomer({
  loading,
  filteredCustomers,
  selected,
  setSelected,
  handleToggleStatus,
  pageCount,
  handlePageClick,
}) {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered mb-0">
        <thead className="table-light">
          <tr>
            <th>Select</th>
            <th>Customer Name</th>
            <th>Customer Code</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Phone</th>
            <th>Website</th>
            <th>Address</th>
            <th>Country</th>
            <th>State</th>
            <th>District</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="14" className="text-center py-4">
                <Loading />
              </td>
            </tr>
          ) : filteredCustomers.length > 0 ? (
            filteredCustomers.map((c) => {
              const isInactive = c.status !== "Active";

              return (
                <tr key={c.id} className={isInactive ? "table-secondary" : ""}>
                  <td>
                    <input
                      type="radio"
                      name="customerSelect"
                      checked={selected?.id === c.id}
                      onChange={() => setSelected(c)}
                      disabled={c.status !== "Active"}
                    />
                  </td>
                  <td>{c.customerName}</td>
                  <td>{c.customerCode}</td>
                  <td>{c.firstName}</td>
                  <td>{c.lastName}</td>
                  <td>{c.emailId}</td>
                  <td>{c.mobileNo}</td>
                  <td>{c.phone}</td>
                  <td>
                    <a href={c.website} target="_blank" rel="noreferrer">
                      {c.website}
                    </a>
                  </td>
                  <td>{c.address}</td>
                  <td>{c.country}</td>
                  <td>{c.state}</td>
                  <td>{c.city}</td>
                  <td>
                    <span
                      className={`badge ${c.status === "Active" ? "bg-success" : "bg-secondary"}`}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleToggleStatus(c.id)}
                    >
                      {c.status}
                    </span>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="14" className="text-center py-3">
                No customers found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <ReactPaginate
        breakLabel="..."
        nextLabel="Next >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        pageCount={pageCount}
        previousLabel="< Previous"
        containerClassName="pagination-container"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        activeClassName="active"
      />
    </div>
  );
}
